// Mock data for Find Me A Lender website

export const teamMembers = [
  {
    id: 1,
    name: "Gaganpreet (Ginny) Gulati",
    role: "Director, Senior Finance Broker & Mentor",
    image: "/ginny_portrait.png"
  },
  {
    id: 2,
    name: "Dilpreet Gulati",
    role: "Senior Finance Broker & National Business Development Manager",
    image: "/dilpreet_portrait.png"
  },
  {
    id: 3,
    name: "Varun (Ron) Sharma",
    role: "Finance Broker, VIC",
    image: "/ron_portrait.png"
  },
  {
    id: 4,
    name: "BP Singh",
    role: "Finance Broker, WA",
    image: "/bp_portrait.png"
  },
  {
    id: 5,
    name: "Arpit Handa",
    role: "Finance Broker, VIC",
    image: "/arpit_portrait.png"
  },
  {
    id: 6,
    name: "Kerry Lam",
    role: "Business Support Officer",
    image: "/kerry_portrait.png"
  }
];

export const services = [
  {
    id: 1,
    title: "Home Loan",
    icon: "Home",
    shortDesc: "Secure your dream home with competitive rates",
    fullDesc: "Buying a home is an exciting milestone, and securing the right home loan is a crucial part of that journey. Whether you're a first-time homebuyer or looking to refinance, understanding your home loan options is essential to make an informed decision. At FindMeaLender.com.au, we're dedicated to providing you with the knowledge and resources you need to navigate the complex world of home financing. Let our experts help you explore various loan types, interest rates, and repayment terms"
  },
  {
    id: 2,
    title: "Asset Finance",
    icon: "Car",
    shortDesc: "Finance your vehicle or equipment with flexible terms",
    fullDesc: "Need finance for another large purchase besides your home? You can also ask us to access competitive finance options for private cars and recreational vehicles, commercial vehicles, plant and equipment for your business and other kinds of small business loans for a variety of purposes."
  },
  {
    id: 3,
    title: "Personal Loan",
    icon: "Wallet",
    shortDesc: "Get funds for any personal need quickly",
    fullDesc: "Need some extra cash for a wedding, medical expenses or travel? Whatever your requirements are a personal loan help you in the time where you need the funds fast. We understand that everybody has different needs when it comes to their finances and finding the right loan solution can be a tedious task. With our team of trusted financing companions, your needs will be covered, and your requirements met."
  },
  {
    id: 4,
    title: "Commercial Loan",
    icon: "Building2",
    shortDesc: "Grow your business with tailored commercial finance",
    fullDesc: "These can included but are not limited unsecured and secured business loans, business line of credit, Invoice Finance Factoring, Merchant Cash Advance and Agriculatural loans. Some of these can be approved and ready for you to access within 24 hours! For find the right solution for your business, do get in touch with our team at Find Me A Lender. "
  }
];

export const lenders = [
  { id: 1, name: "Orde Financials", logo: "/lenders/Orde.jpg" },
  { id: 2, name: "AAA Finance and Insurance", logo: "/lenders/AAA finance.jpg" },
  { id: 3, name: "Ali Group", logo: "/lenders/ali.jpg" },
  { id: 4, name: "Allianz Insurance", logo: "/lenders/allianz.jpg" },
  { id: 5, name: "ANZ Bank", logo: "/lenders/anz.jpg" },
  { id: 6, name: "Assetline Capital", logo: "/lenders/AssetlineCapital1.jpg" },
  { id: 7, name: "Aussie Deposit Bonds", logo: "/lenders/aussie_deposit_bonds.jpg" },
  { id: 8, name: "Australian Military Bank", logo: "/lenders/7149_Australian_Military_Bank_Logo_CMYK_MASTER_21.jpg" },
  { id: 9, name: "Auswide Bank", logo: "/lenders/auswide-bank-logo.jpg" },
  { id: 10, name: "Bank Australia", logo: "/lenders/bank australia.png" },
  { id: 11, name: "Bank of Sydney", logo: "/lenders/bankofsydney.png" },
  { id: 12, name: "BankVic", logo: "/lenders/BankVic_logo_450px.jpg" },
  { id: 13, name: "Bendigo Bank", logo: "/lenders/bendigo-bank-broker-logo_de7f4a.jpg" },
  { id: 14, name: "Better Choice", logo: "/lenders/Better_Choice_Home_Loans.jpg" },
  { id: 15, name: "Better Mortgage Management", logo: "/lenders/logo-hero_and_about_2x_ojgho5.jpg" },
  { id: 16, name: "Beyond Bank", logo: "/lenders/BeyondBank-logo.jpg" },
  { id: 17, name: "Bluestone Home Loans", logo: "/lenders/bluestone.jpg" },
  { id: 18, name: "Bluebay Home Loans", logo: "/lenders/bluebay.jpg" },
  { id: 19, name: "Bank of Queensland", logo: "/lenders/boq.jpg" },
  { id: 20, name: "Copilot", logo: "/lenders/copilotfinanceandinsurance_logo.jpg" },
  { id: 21, name: "Commonwealth Bank", logo: "/lenders/commonwealthbank.jpg" },
  { id: 22, name: "Compass Aggregation", logo: "/lenders/Compass.jpg" },
  { id: 23, name: "Deposit Power", logo: "/lenders/depositpower.jpg" },
  { id: 24, name: "Deposit Bond Australia", logo: "/lenders/depositbondaustralia.jpg" },
  { id: 25, name: "Deposit Assure", logo: "/lenders/deposit assure.jpg" },
  { id: 26, name: "Firefighters Mutual Bank", logo: "/lenders/firefighters mutual bank.jpg" },
  { id: 27, name: "Firstmac", logo: "/lenders/firstmac.jpg" },
  { id: 28, name: "Great Southern Bank", logo: "/lenders/great southern bank.jpg" },
  { id: 29, name: "Heartland Reverse Mortgages", logo: "/lenders/heratland.jpg" },
  { id: 30, name: "Heritage Bank", logo: "/lenders/heritagebank.jpg" },
  { id: 31, name: "Honey", logo: "/lenders/honey.jpg" },
  { id: 32, name: "Household Capital", logo: "/lenders/householdcapital.jpg" },
  { id: 33, name: "Moneyplace", logo: "/lenders/moneyplace.jpg" },
  { id: 34, name: "ING", logo: "/lenders/ing.jpg" },
  { id: 35, name: "Judobank", logo: "/lenders/judobank.jpg" },
  { id: 36, name: "Keystart", logo: "/lenders/keystart.jpg" },
  { id: 37, name: "LaTrobe Financial", logo: "/lenders/latrobe fiancial.jpg" },
  { id: 38, name: "Latitude", logo: "/lenders/latitude.jpg" },
  { id: 39, name: "Liberty", logo: "/lenders/liberty.jpg" },
  { id: 40, name: "Wisr", logo: "/lenders/wisr.jpg" },
  { id: 41, name: "Macquarie Bank", logo: "/lenders/macquarie bank.jpg" },
  { id: 42, name: "MA Money", logo: "/lenders/ma money.jpg" },
  { id: 43, name: "Medfin Finance", logo: "/lenders/medfin.jpg" },
  { id: 44, name: "Me Bank", logo: "/lenders/mebank.jpg" },
  { id: 45, name: "EZY Mortgage", logo: "/lenders/ezy mortgage.jpg" },
  { id: 46, name: "Move Bank", logo: "/lenders/movebank.jpg" },
  { id: 47, name: "Movinghub", logo: "/lenders/movinghub.jpg" },
  { id: 48, name: "MyStateBank", logo: "/lenders/mystatebank.jpg" },
  { id: 49, name: "NAB", logo: "/lenders/nab.png" },
  { id: 50, name: "Now Finance", logo: "/lenders/nowfinance.jpg" },
  { id: 51, name: "Oak Capital", logo: "/lenders/oakcapital.png" },
  { id: 52, name: "Paramount", logo: "/lenders/paramount.jpg" },
  { id: 53, name: "People First Bank", logo: "/lenders/peoplefirstbank.png" },
  { id: 54, name: "Pepper Money", logo: "/lenders/peppermoney.png" },
  { id: 55, name: "Platform Finance", logo: "/lenders/platformfinance.png" },
  { id: 56, name: "Plenti", logo: "/lenders/plenti.png" },
  { id: 57, name: "P&N Bank", logo: "/lenders/p and n.jpg" },
  { id: 58, name: "Prime Capital", logo: "/lenders/prime capital.png" },
  { id: 59, name: "Prospa", logo: "/lenders/prospa.png" },
  { id: 60, name: "Qudos Bank", logo: "/lenders/qudos.png" },
  { id: 61, name: "Resimac", logo: "/lenders/resimac.jpg" },
  { id: 62, name: "Resimac Asset Finance", logo: "/lenders/resimac asset fin.jpg" },
  { id: 63, name: "Shift", logo: "/lenders/shift.png" },
  { id: 64, name: "St. George", logo: "/lenders/st george.png" },
  { id: 65, name: "Suncorp Bank", logo: "/lenders/suncorp.jpg" },
  { id: 66, name: "Teachers Mutual Bank", logo: "/lenders/teachers mutual bank.png" },
  { id: 67, name: "Thinktank", logo: "/lenders/thinktank.png" },
  { id: 68, name: "Ubank", logo: "/lenders/ubank.png" },
  { id: 69, name: "UniBank", logo: "/lenders/unibank.png" },
  { id: 70, name: "Virgin Money", logo: "/lenders/virginmoney.png" },
  { id: 71, name: "VMG", logo: "/lenders/vmg.jpg" },
  { id: 72, name: "Westpac Group", logo: "/lenders/westpacgroup.png" },
  { id: 73, name: "WLTH", logo: "/lenders/wlth.png" }
];

export const googleReviews = [
  {
    id: 1,
    name: "Bradley Quinn",
    rating: 5,
    date: "19/06/2026",
    text: "Absolutely best experience with Dilpreet and his team, such a easy process, 100 percent recommend him, thanks guys.",
    avatar: "https://lh3.googleusercontent.com/a/ACg8ocKRNJKV4819Mfo4FirqnRKN64LUVjmII6_Kt_Vd07nKDxdNEw=w72-h72-p-rp-mo-br100",
    link: "https://maps.app.goo.gl/NeUZvESYC7i7meut5"
  },
  {
    id: 2,
    name: "Sophia Mai",
    rating: 5,
    date: "12/06/2026",
    text: "My partner and I had such a great experience working with Varun! He really went out of his way and no question was too much for him to answer. Thank you so much!",
    avatar: "https://lh3.googleusercontent.com/a-/ALV-UjWrJwnlZmEd0AR98N7yFuPJuwXN3nR6IZHhWuyP--tE8PuuXRLU=w72-h72-p-rp-mo-br100",
    link: "https://maps.app.goo.gl/ntwqy16V1iK5TrQq7"
  },
  {
    id: 3,
    name: "Varinder Sandhu",
    rating: 5,
    date: "22/06/2026",
    text: "⭐⭐⭐⭐⭐ Excellent service from B.P. Singh and Arvi! They were professional, helpful, and made the entire home loan process smooth and stress-free. Always quick to respond and guided me every step of the way. Highly recommend them! thank you guys.",
    avatar: "https://lh3.googleusercontent.com/a-/ALV-UjWQQU1dUYhFysA5GRhQWA6Z-gV5bVXsxjdgqyGJQ186GlHsq7Y=s36-c-rp-mo-br100",
    link: "https://maps.app.goo.gl/fkvLbv3sereaDMVn6"
  },
  {
    id: 4,
    name: "Manmeet Singh",
    rating: 5,
    date: "19/03/2026",
    text: "We had a fantastic experience with Dilpreet Singh. Nothing was too hard and everything was explained along the way. Communication was fabulous. Highly recommend to everyone for better their financial position.",
    avatar: "https://lh3.googleusercontent.com/a/ACg8ocLW8EHaOq4RU2QQbnmoZXAttwKIcqAjIPosa47vUxwyVQAp8g=w72-h72-p-rp-mo-ba2-br100",
    link: "https://share.google/aGfQMio1cKBPZetAn"  
  },
  {
    id: 5,
    name: "Jayce Lee",
    rating: 5,
    date: "21/05/2026",
    text: "They were extremely helpful and able to answer all of my questions quickly and without any issues. When a communication error occurred with my conveyancer, they stepped in promptly and resolved it before any problems arose. They treated the entire process as if they were buying the house themselves, which gave me a lot of confidence and peace of mind. I highly recommend their service to anyone looking for a reliable and dedicated broker.",
    avatar: "https://lh3.googleusercontent.com/a-/ALV-UjVGZxswB5fhslesaxTgGS9VKONcZJM2Jpe1Zl6pAKvqatWrZ24=s36-c-rp-mo-br100",
    link: "https://maps.app.goo.gl/burs82EoFYEGG8HX6"  
  },
  {
    id: 6,
    name: "Vish Shah",
    rating: 5,
    date: "09/03/2026",
    text: "We recently worked with Dilpreet Gulati on a complex loan application to finance the construction of a Specialist Disability Accommodation (SDA) home under the NDIS framework. This is not a straightforward lending proposition — SDA projects involve unique regulatory requirements, specialist assessments, and a level of complexity that many lenders and brokers simply aren't equipped to handle. Dilpreet approached our application with genuine commitment and thoroughness. He took the time to understand the nuances of SDA funding, engaged with the complexity without hesitation, and kept the process moving when it could easily have stalled. His communication was consistent and clear throughout, and when challenges arose — as they inevitably do with applications of this nature — he worked through them with persistence rather than passing them back to us. What stood out most was his wholehearted involvement. This wasn't a transactional experience. Dilpreet invested real effort into securing the right outcome for us, and that made a significant difference in what was a demanding and high-stakes process. We would not hesitate to recommend Dilpreet to any developer, investor, or provider working in the disability housing space. He has earned our trust and our repeat business.",
    avatar: "https://lh3.googleusercontent.com/a/ACg8ocIIYiRAJ_Yue_k0kIYiD87ZNHfIrXDRDoEtF0fWg2TMFrnECw=w72-h72-p-rp-mo-br100",
    link: "https://share.google/7eNunbK5CipOrhUPB"  
  }
  /*
  Review template
      id: ,
    name: "",
    rating: ,
    date: "",
    text: "",
    avatar: "",
    link: "" 
  */
];

export const faqs = [
  {
    question: "What does a Mortgage Broker do?",
    answer: "Mortgage brokers are qualified professionals in the finance sector. They collaborate with you to identify your borrowing goals and needs, and assist you in calculating your borrowing capacity. Brokers work to prevent you from taking out a loan that is not right for you. We are experts in what we do, much like your lawyer, accountant, or financial planner, and we will offer you a suitable financing option to assist you in reaching your objectives. Additionally, a very large number of lenders' finance solutions are available to our brokers, so your broker can compare lending items from a large range of lenders."
  },
  {
    question: "Do you just recommend the lender who pays you the highest commission?",
    answer: "There is very little difference between the commissions paid by the various lenders. There is also legislation in our industry called the National Consumer Credit Protection Act (or NCCP), that is designed to protect consumers and ensure ethical and professional standards in the finance industry. We tell you upfront what commission we will be getting from the lender. Our job is to find a competitive loan for your needs and objectives."
  },
  {
    question: "How much can I borrow?",
    answer: "Income, employment position, the deposit saved, current living expenses and any liabilities are specific factors that need to be considered when determining how much a customer can borrow. Please give us a call and we can go into your options and discuss your circumstances in more detail."
  },
  {
    question: "Can we still work together even if I don't live in your area?",
    answer: "Yes! We can travel to you or we can schedule a video call. We service clients all over Australia."
  },
  {
    question: "Who determines the interest rates?",
    answer: "Mortgage brokers do not set rates. The Reserve Bank of Australia meet on the first Tuesday of every month to determine the official cash rate for the country. The lenders then use this information to set their own rates. Lenders also adjust their rates according to their costs and other economic considerations."
  },
  {
    question: "Do you charge fees for home and investment loans?",
    answer: "Some mortgage brokers charge a fee for their services and some don't. When you take out a loan via a mortgage broker, it does not cost you more in loan repayments. Brokers get paid a commission by the lender for bringing new business to them, but this does not impact your interest rate. We must disclose any fees upfront to you so that you know what it will cost if you engage our services."
  },
  {
    question: "Should I go fixed or variable?",
    answer: "A mortgage broker will recommend a product based on what you say is most important to you. We do however, live by the following: 'if you want flexibility take a variable rate loan, if you want budget certainty, take a fixed rate loan, if you want both, then do a split loan.'"
  },
  {
    question: "Which lenders do you deal with?",
    answer: "We are Connective Brokers and we have access to many lenders. This means we can source you a loan from different lenders to provide you with a variety of options that are suitable for you and your situation."
  },
  {
    question: "Why should I use a mortgage broker if I can go with a bank?",
    answer: "Lenders and banks will solely promote their own products. Each bank (or lender) has a variety of loan products on offer – low doc, package loans, loans with re-draw facilities, plant and equipment loans, fixed rate loans, interest only, interested in advance, variable, introductory variable… and so on. The issue you face as a consumer is ‘which loan is right for me?’ And that is where your mortgage broker becomes an invaluable resource! If you go direct to the bank, you will only be offered the loan options available through that one lender. As your mortgage broker, we do all the leg work to find the right loan from the right lender, for YOUR needs. We have connections across many lenders and can see all of their loan products, and our sole purpose is to find a suitable loan to match your personal financial circumstances and goals. "
  }
];

export const blogPosts = [
  { id: 1, title: "Navigating Mortgages on the Gold Coast: Your Comprehensive Guide", location: "Gold Coast", excerpt: "Everything you need to know about testing blog links lol.", image: "https://images.unsplash.com/photo-1670303688566-58ec806c7661?w=400", date: "2024-09-27", link: "/blog1" },
  { id: 2, title: "Melbourne Property Investment Tips 2025", location: "Melbourne", excerpt: "Expert insights on investing in Melbourne's property market.", image: "https://images.unsplash.com/photo-1670303688605-243b86bea1bf?w=400", date: "2025-01-12", link: "#blog-2" },
  { id: 3, title: "Gold Coast Refinancing: When and Why", location: "Gold Coast", excerpt: "Learn when it's the right time to refinance your Gold Coast property.", image: "https://images.unsplash.com/photo-1606788075819-9574a6edfab3?w=400", date: "2025-01-10", link: "#blog-3" },
  { id: 4, title: "Understanding Interest Rates in 2025", location: "National", excerpt: "How interest rates affect your mortgage and what to expect.", image: "https://images.unsplash.com/photo-1609220136736-443140cffec6?w=400", date: "2025-01-08", link: "#blog-4" },
  { id: 5, title: "Cairns First Home Buyer Grants", location: "Cairns", excerpt: "Government assistance programs available for Cairns home buyers.", image: "https://images.pexels.com/photos/4617316/pexels-photo-4617316.jpeg?w=400", date: "2025-01-05", link: "#blog-5" },
  { id: 6, title: "Commercial Property Loans Explained", location: "National", excerpt: "A comprehensive guide to commercial lending in Australia.", image: "https://images.unsplash.com/photo-1476703993599-0035a21b17a9?w=400", date: "2025-01-03", link: "#blog-6" },
  { id: 7, title: "Melbourne's Best Suburbs for Investment", location: "Melbourne", excerpt: "Top Melbourne suburbs delivering strong rental yields.", image: "https://images.pexels.com/photos/4783976/pexels-photo-4783976.jpeg?w=400", date: "2024-12-28", link: "#blog-7" },
  { id: 8, title: "Gold Coast Market Update 2025", location: "Gold Coast", excerpt: "Latest trends and predictions for Gold Coast property.", image: "https://images.unsplash.com/photo-1752170080773-fed7758395c3?w=400", date: "2024-12-25", link: "#blog-8" },
  { id: 9, title: "Asset Finance for Small Business", location: "National", excerpt: "How to leverage asset finance to grow your business.", image: "https://images.unsplash.com/photo-1758518732175-5d608ba3abdf?w=400", date: "2024-12-20", link: "#blog-9" },
  { id: 10, title: "Cairns Coastal Living Investment Guide", location: "Cairns", excerpt: "Why Cairns is attracting property investors nationwide.", image: "https://images.unsplash.com/photo-1683770997177-0603bd44d070?w=400", date: "2024-12-18", link: "#blog-10" },
  { id: 11, title: "Debt Consolidation Strategies", location: "National", excerpt: "Smart ways to consolidate debt through refinancing.", image: "https://images.unsplash.com/photo-1670851050245-d861fd433d06?w=400", date: "2024-12-15", link: "#blog-11" },
  { id: 12, title: "Melbourne Inner City Apartment Market", location: "Melbourne", excerpt: "Is now the right time to buy a Melbourne apartment?", image: "https://images.unsplash.com/photo-1650919997970-7f512398bb66?w=400", date: "2024-12-12", link: "#blog-12" },
  { id: 13, title: "Gold Coast Luxury Property Trends", location: "Gold Coast", excerpt: "High-end property market analysis for Gold Coast.", image: "https://images.unsplash.com/photo-1710317496185-d1fc01458200?w=400", date: "2024-12-10", link: "#blog-13" },
  { id: 14, title: "Self-Employed Home Loan Tips", location: "National", excerpt: "Navigate home loans when you're self-employed.", image: "https://images.unsplash.com/photo-1664393485705-b3ca8a8eebb8?w=400", date: "2024-12-08", link: "#blog-14" },
  { id: 15, title: "Cairns Holiday Home Financing", location: "Cairns", excerpt: "Finance options for Cairns holiday properties.", image: "https://images.unsplash.com/photo-1670303688605-243b86bea1bf?w=400", date: "2024-12-05", link: "#blog-15" },
  { id: 16, title: "Melbourne Stamp Duty Savings Guide", location: "Melbourne", excerpt: "Reduce your stamp duty costs in Melbourne.", image: "https://images.unsplash.com/photo-1670303688566-58ec806c7661?w=400", date: "2024-12-03", link: "#blog-16" },
  { id: 17, title: "Building Your First Home in Australia", location: "National", excerpt: "Construction loan essentials for first-time builders.", image: "https://images.unsplash.com/photo-1606788075819-9574a6edfab3?w=400", date: "2024-11-30", link: "#blog-17" },
  { id: 18, title: "Gold Coast Family Home Buyer's Checklist", location: "Gold Coast", excerpt: "What to look for when buying a family home on the Gold Coast.", image: "https://images.unsplash.com/photo-1609220136736-443140cffec6?w=400", date: "2024-11-28", link: "#blog-18" },
  { id: 19, title: "Investment Property Tax Benefits", location: "National", excerpt: "Understanding tax deductions for property investors.", image: "https://images.pexels.com/photos/4617316/pexels-photo-4617316.jpeg?w=400", date: "2024-11-25", link: "#blog-19" },
  { id: 20, title: "Melbourne vs Cairns: Property Comparison", location: "Melbourne", excerpt: "Comparing property markets between Melbourne and Cairns.", image: "https://images.unsplash.com/photo-1476703993599-0035a21b17a9?w=400", date: "2024-11-22", link: "#blog-20" }
];

export const careerInfo = {
  title: "Start Your Career with Find Me A Lender",
  introduction: "Join Australia's leading mortgage brokering team and make a real difference in people's lives. We're always looking for passionate, driven individuals who want to build a rewarding career in finance.",
  benefits: [
    "Competitive commission structures",
    "Comprehensive training and professional development",
    "Flexible work arrangements and supportive team environment",
    "Learn under a certified mentor with The Finance Brokers Association of Australiasia",
    "Clear career progression pathways",
    "Access to leading technology and CRM systems"
  ],
  roles: [
    {
      title: "Mortgage Broker",
      description: "Work directly with clients to secure the best home loan solutions. Full training provided for candidates with the right attitude and commitment."
    },
    {
      title: "Finance Consultant",
      description: "Provide expert advice across our full range of lending products including home loans, personal loans, and commercial finance."
    },
    {
      title: "Client Support Officer",
      description: "Support our broker team with administrative tasks, client communications, and loan processing."
    }
  ]
};
